var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCropSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 384H432V120C432 97.938 414.062 80 392 80H160V128H384V488C384 501.25 394.75 512 408 512S432 501.25 432 488V432H488C501.25 432 512 421.25 512 408S501.25 384 488 384ZM128 384V24C128 10.75 117.25 0 104 0S80 10.75 80 24V80H24C10.75 80 0 90.75 0 104S10.75 128 24 128H80V392C80 414.062 97.938 432 120 432H352V384H128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropSimple);
export default __webpack_public_path__ + "static/media/crop-simple.f7765d6681b5e9c0133e2a91e9399bfe.svg";
export { ForwardRef as ReactComponent };